import React, { useState, useEffect, useContext } from "react"
import styled from "styled-components"
import { SectionContext } from "../../context/sectionContext"
import { JourneyContext } from "../../context/journeyContext"
import { ConditionContext } from "../../context/conditionContext"
import { getValueFromJourney } from "../../services/helperFunctions"
import { insWords, applyComma, wordCapital, lineCapital } from "../../../shared/functions"
import { ErrorContext } from "../../context/errorContext"
import { isIE } from 'react-device-detect';
import { ifscCodeDetails } from "../../../services/apiservice"
import * as lookup from "../../../..//static/lookup.json"
import * as journey_lookup from "../../../../static/journey_lookup.json"

const InputContainer = styled.div`
  display: block;
  flex-direction: column;
  margin: 15px 0;
  margin-top:12px !important;
  position: relative;
  box-sizing: border-box;
  font-size: 15px;
  color: #505050;
  float: left;

  & > .str-input {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  & input {
    border: none;
    outline: none;
    margin: 0;
    padding: 0;
    line-height: 4;
    height: 42px;
    background: ${props => props.channel === "A" || props.channel === "28" || props.channel === "35" ? "#ededed" : "#fff"};
    background: var(--lumiq-bg);
  }

  & > label {
    margin-left: 8px;
    margin-bottom: 5px;
    color: #505050;
    font-size: 16px;
    background: ${props => props.channel === "A" || props.channel === "28" || props.channel === "35" ? "#ededed" : "#fff"};
    background: var(--lumiq-bg);
    padding: 2px 5px;
    /* z-index: 999; */
    position: relative;
    display: inline-block;
    cursor: default;
    max-width: 100%;
  }
`
const numToWordFormControlKey = ["AnnualIncome", "sumAssured"]

// Helper functions for universal validation
const isPhoneNumberField = (formControlKey) => {
  if (!formControlKey) return false
  const key = formControlKey.toLowerCase()
  return key.includes("contact") || key.includes("mobile") || key.includes("phone")
}

const isPincodeField = (formControlKey) => {
  if (!formControlKey) return false
  return formControlKey.toLowerCase().includes("pincode")
}

const getCountryFieldForRepeatable = (formControlKey, sectionData, index, conditionState) => {
  // For repeatable components, check if it's nominee-related
  if (formControlKey && formControlKey.toLowerCase().includes("nominee")) {
    // Check if nomineeCountry exists in sectionData (could be array)
    if (sectionData && sectionData["nomineeCountry"]) {
      if (Array.isArray(sectionData["nomineeCountry"])) {
        return sectionData["nomineeCountry"][index]
      }
      return sectionData["nomineeCountry"]
    }
    // Also check conditionState for nomineeCountry
    if (conditionState) {
      const conditionKey = Object.keys(conditionState).find(key => key.includes("nomineeCountry"))
      if (conditionKey && conditionState[conditionKey]) {
        if (Array.isArray(conditionState[conditionKey])) {
          return conditionState[conditionKey][index]
        }
        return conditionState[conditionKey]
      }
    }
  }
  
  // Check other country fields
  const countryFields = [
    "country", "countryofbirth", "proposerCountry", "currentCountryofResidence",
    "GIFTcountry", "countryGiftCity", "jointlifeCommunicationCountry",
    "jointlifePermanentAddressCountry", "eaCountry"
  ]
  
  for (const field of countryFields) {
    if (sectionData && sectionData[field]) {
      if (Array.isArray(sectionData[field])) {
        return sectionData[field][index]
      }
      return sectionData[field]
    }
  }
  
  // Also check conditionState
  if (conditionState) {
    for (const field of countryFields) {
      const conditionKey = Object.keys(conditionState).find(key => key.includes(field) && !key.includes("contactCountryCode"))
      if (conditionKey && conditionState[conditionKey]) {
        if (Array.isArray(conditionState[conditionKey])) {
          return conditionState[conditionKey][index]
        }
        return conditionState[conditionKey]
      }
    }
  }
  
  return null
}

export default function RepeatableComponentTextString(props) {
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [errorState, setErrorState] = useContext(ErrorContext)
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  const [conditionState, setConditionState] = useContext(ConditionContext)
  const [showLocalError, setShowLocalError] = useState(false)

  const validate = target => {
    let temp
    let temp1
    if (errorState[props.data.formControlKey]) {
      temp1 = errorState[props.data.formControlKey]
    } else {
      temp1 = []
    }
    if (props.data.required) {
      //   required field validation
      if (!sectionState.sectionData[props.data.formControlKey] || !sectionState.sectionData[props.data.formControlKey][props.index]) {
        // console.log("dchdh1", props, sectionState)
        temp1[props.index] = (getValueFromJourney(
          journeyState.lookup.required_error,
          props.data.requiredError
        ))
        temp = temp1
        setErrorState(prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: temp
          })
        })
        return
      }
      if ((sectionState.sectionData[props.data.formControlKey]) && (!sectionState.sectionData[props.data.formControlKey][props.index])) {
        temp1[props.index] = (getValueFromJourney(
          journeyState.lookup.required_error,
          props.data.requiredError
        ))
        temp = temp1
        setErrorState(prev => {
          // console.log("dchdh2", props, sectionState)
          return ({
            ...prev,
            [props.data.formControlKey]: temp
          })
        })
      } else {
        temp1[props.index] = ""
        temp = temp1
        setErrorState(prev => {
          // console.log("dchdh3", props, sectionState)
          return ({
            ...prev,
            [props.data.formControlKey]: temp
          })
        })
      }
      temp1[props.index] = ""
      temp = temp1
      if (target.value) {
        // console.log("dchdh4", props, sectionState)
        setErrorState(prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: temp
          })
        })
      }
    }
    if (target.value) {
      // Special validation for pincode outside India - minimum length should be 3
      if (isPincodeField(props.data.formControlKey)) {
        const countryValue = getCountryFieldForRepeatable(props.data.formControlKey, sectionState.sectionData, props.index, conditionState)
        // If country is not India and pincode length is less than 3
        if (countryValue && countryValue !== "IN" && target.value.length > 0 && target.value.length < 3) {
          temp1[props.index] = "Minimum length should be 3"
          temp = temp1
          setErrorState(prev => {
            return {
              ...prev,
              [props.data.formControlKey]: temp,
            }
          })
          setShowLocalError(true)
          return
        }
      }
      
      if (props.data.min_len) {
        // min_len validation
        if (target.value.length < props.data.min_len) {
          temp1[props.index] = (getValueFromJourney(
            journeyState.lookup.min_error,
            props.data.min_len_error
          ))
          temp = temp1
          setErrorState(prev => {
            return {
              ...prev,
              [props.data.formControlKey]: temp,
            }
          })
          setShowLocalError(true)
          return
        } else {
          temp1[props.index] = ""
          temp = temp1
          setErrorState(prev => {
            return {
              ...prev,
              [props.data.formControlKey]: temp,
            }
          })
        }
      }
      if (props.data.max_length) {
        //max length validation
        // Special handling for pincode outside India - show correct max length (9)
        if (isPincodeField(props.data.formControlKey)) {
          const countryValue = getCountryFieldForRepeatable(props.data.formControlKey, sectionState.sectionData, props.index, conditionState)
          // If country is not India, show max length as 9
          if (countryValue && countryValue !== "IN" && target.value.length > props.data.max_length) {
            temp1[props.index] = `${(getValueFromJourney(
              journeyState.lookup.label,
              props.data.label
            )) || props.data.label} can maximum be of 9 characters`
            temp = temp1
            setErrorState(prev => {
              return {
                ...prev,
                [props.data.formControlKey]: temp,
              }
            })
            setShowLocalError(true)
            return
          }
        }
        
        if (target.value.length > props.data.max_length) {
          temp1[props.index] = (getValueFromJourney(
            journeyState.lookup.max_error,
            props.data.max_len_error
          ))

          temp = temp1
          setErrorState(prev => {
            return {
              ...prev,
              [props.data.formControlKey]: temp,
            }
          })
          setShowLocalError(true)
          return
        } else {
          temp1[props.index] = ""
          temp = temp1
          setErrorState(prev => {
            return {
              ...prev,
              [props.data.formControlKey]: temp
            }
          })
        }
      }
      if(target.value){
        let pattern = /[\<\>\[\{\]\}\^\?\(\)]/
        let n = pattern.test(target.value.toString())
        if(n){
          temp1[props.index] = `Please enter valid ${(getValueFromJourney(
            journeyState.lookup.label,
            props.data.label
          )) || props.data.label}`
        temp=temp1
        setErrorState(prev => {
          return {
            ...prev,
            [props.data
              .formControlKey]: temp,
          }
        })
        setShowLocalError(true)
        return
        }
      }
      if (props.data.regex) {
        let regex = props.data.regex.toString()
        let rg = regex.substring(1, regex.lastIndexOf("/"))
        let flags = regex.substring(regex.lastIndexOf("/") + 1)
        let regex_exp = new RegExp(rg, flags)
        if (regex_exp.test(target.value)) {
          temp1[props.index] = ""
          temp = temp1
          setErrorState(prev => {
            return {
              ...prev,
              [props.data.formControlKey]: temp,
            }
          })
        } else {
          temp1[props.index] = (getValueFromJourney(
            journeyState.lookup.required_error,
            props.data.regexError
          ))
          temp = temp1
          setErrorState(prev => {
            return {
              ...prev,
              [props.data
                .formControlKey]: temp,
            }
          })
          setShowLocalError(true)
          return
        }
      }

    }
    if (props.data.formControlKey === "ifAliveDisease") {
      let familyMemberValue
      let changeFamilyMember
      if (errorState["familyMemberHealthLA"]) {
        familyMemberValue = errorState["familyMemberHealthLA"]
      } else {
        familyMemberValue = []
      }
      if (target.value) {
        if (!sectionState.sectionData.hasOwnProperty('familyMemberHealthLA') || sectionState.sectionData['familyMemberHealthLA'][props.index] == undefined||sectionState.sectionData['familyMemberHealthLA'][props.index] == "") {
          familyMemberValue[props.index] = "Please select Family Member"
          changeFamilyMember = familyMemberValue
           setErrorState(prev => {
            return ({
              ...prev,
              ["familyMemberHealthLA"]: changeFamilyMember
            })
          })
        }
        setShowLocalError(true)
          return
      }
      else {
        familyMemberValue[props.index] = ""
        changeFamilyMember = familyMemberValue
        setErrorState(prev => {
          return ({
            ...prev,
            ["familyMemberHealthLA"]: changeFamilyMember
          })
        })
        setShowLocalError(true)
        return
      }
    }
    // console.log(errorState, "error State")
    return
  }

  // Universal Phone Number Validation for Repeatable Components
  useEffect(() => {
    if (!isPhoneNumberField(props.data.formControlKey)) return
    
    // Check for contactCountryCode or countryCodeNominee/nomineeCountryCode (for nominee-related phone fields)
    let contactCountryCode = null
    let isNomineePhone = false
    
    // For nominee-related phone fields, check countryCodeNominee or nomineeCountryCode
    if (props.data.formControlKey && (props.data.formControlKey.toLowerCase().includes("nominee") || props.data.formControlKey.toLowerCase().includes("contactnominee"))) {
      isNomineePhone = true
      // Check countryCodeNominee first
      if (sectionState.sectionData?.["countryCodeNominee"]) {
        if (Array.isArray(sectionState.sectionData["countryCodeNominee"])) {
          contactCountryCode = sectionState.sectionData["countryCodeNominee"][props.index]
        } else {
          contactCountryCode = sectionState.sectionData["countryCodeNominee"]
        }
      } else if (sectionState.sectionData?.["nomineeCountryCode"]) {
        if (Array.isArray(sectionState.sectionData["nomineeCountryCode"])) {
          contactCountryCode = sectionState.sectionData["nomineeCountryCode"][props.index]
        } else {
          contactCountryCode = sectionState.sectionData["nomineeCountryCode"]
        }
      }
    } else {
      // For other phone fields, check contactCountryCode
      if (sectionState.sectionData?.["contactCountryCode"]) {
        contactCountryCode = sectionState.sectionData["contactCountryCode"]
      }
    }
    
    if (!contactCountryCode) return
    
    const isIndia = contactCountryCode === "+91"
    let temp = journeyState.journeySteps
    let updated = false
    
    // Find the component in journeySteps for this repeatable instance
    temp.pages.forEach((page) => {
      page.sections.forEach((section) => {
        section.component_groups.forEach((componentGroup) => {
          componentGroup.components.forEach((component) => {
            if (component.formControlKey === props.data.formControlKey) {
              if (isIndia) {
                // For India, use AlphaWealth pattern: 10 digits with specific regex for nominee phones
                if (isNomineePhone) {
                  component.min_len = 10
                  component.max_len = 10
                  component.max_length = 10
                  component.regex = "/(?!9999999999|8888888888|7777777777|6666666666)(^[6-9][0-9]{9}$)/"
                  component.regexError = "E168"
                } else {
                  component.min_len = 10
                  component.max_length = 10
                  component.max_len = 10
                  component.regex = "/^[0-9]{10}$/"
                }
              } else {
                // For outside India, use AlphaWealth pattern: 9-15 digits
                if (isNomineePhone) {
                  component.min_len = 9
                  component.max_len = 15
                  component.max_length = 15
                  component.regex = null
                  component.regexError = null
                } else {
                  component.min_len = 7
                  component.max_length = 15
                  component.max_len = 15
                  component.regex = "/^[0-9]+$/"
                }
              }
              updated = true
            }
          })
        })
      })
    })
    
    if (updated) {
      setJourneyState(prev => ({
        ...prev,
        journeySteps: temp
      }))
    }
  }, [
    sectionState.sectionData?.["contactCountryCode"],
    sectionState.sectionData?.["countryCodeNominee"]?.[props.index],
    sectionState.sectionData?.["countryCodeNominee"],
    sectionState.sectionData?.["nomineeCountryCode"]?.[props.index],
    sectionState.sectionData?.["nomineeCountryCode"],
    props.data.formControlKey,
    props.index
  ])

  // Universal Pincode Validation for Repeatable Components - nomineeCountry controls nomineePincode
  useEffect(() => {
    if (!isPincodeField(props.data.formControlKey)) return
    
    // Get country value for this specific index
    let countryValue = null
    
    // Check nomineeCountry first (for nominee-related fields)
    if (props.data.formControlKey && props.data.formControlKey.toLowerCase().includes("nominee")) {
      if (sectionState.sectionData?.["nomineeCountry"]) {
        if (Array.isArray(sectionState.sectionData["nomineeCountry"])) {
          countryValue = sectionState.sectionData["nomineeCountry"][props.index]
        } else {
          countryValue = sectionState.sectionData["nomineeCountry"]
        }
      }
    }
    
    // Check other country fields
    if (!countryValue) {
      const countryFields = [
        "country", "countryofbirth", "proposerCountry", "currentCountryofResidence",
        "GIFTcountry", "countryGiftCity", "jointlifeCommunicationCountry",
        "jointlifePermanentAddressCountry", "eaCountry", "nomineeCountry"
      ]
      
      for (const field of countryFields) {
        if (sectionState.sectionData?.[field]) {
          if (Array.isArray(sectionState.sectionData[field])) {
            countryValue = sectionState.sectionData[field][props.index]
          } else {
            countryValue = sectionState.sectionData[field]
          }
          if (countryValue) break
        }
      }
    }
    
    // Also check conditionState
    if (!countryValue) {
      const conditionKey = Object.keys(conditionState).find(key => 
        key.includes("nomineeCountry") || 
        (key.includes("country") && !key.includes("contactCountryCode"))
      )
      if (conditionKey && conditionState[conditionKey]) {
        if (Array.isArray(conditionState[conditionKey])) {
          countryValue = conditionState[conditionKey][props.index]
        } else {
          countryValue = conditionState[conditionKey]
        }
      }
    }
    
    if (!countryValue) return
    
    const isIndia = countryValue === "IN"
    let temp = journeyState.journeySteps
    let updated = false
    
    // Find the component in journeySteps for this repeatable instance
    temp.pages.forEach((page) => {
      page.sections.forEach((section) => {
        section.component_groups.forEach((componentGroup) => {
          componentGroup.components.forEach((component) => {
            if (component.formControlKey === props.data.formControlKey) {
              if (isIndia) {
                component.min_len = 6
                component.max_length = 6
                component.max_len = 6
                component.regex = null
                component.__typename = "ComponentCmpTagNumber"
              } else {
                component.min_len = 3
                component.max_length = 9
                component.max_len = 9
                component.regex = "/^[a-zA-Z0-9 ]+$/"
                component.__typename = "ComponentCmpTagTextString"
              }
              updated = true
            }
          })
        })
      })
    })
    
    if (updated) {
      setJourneyState(prev => ({
        ...prev,
        journeySteps: temp
      }))
    }
  }, [
    sectionState.sectionData?.["nomineeCountry"]?.[props.index],
    sectionState.sectionData?.["nomineeCountry"],
    sectionState.sectionData?.["country"]?.[props.index],
    sectionState.sectionData?.["country"],
    sectionState.sectionData?.["countryofbirth"]?.[props.index],
    sectionState.sectionData?.["countryofbirth"],
    props.data.formControlKey,
    props.index
  ])

  useEffect(() => {
    validate({
      value: (sectionState.sectionData[props.data.formControlKey] ? sectionState.sectionData[props.data.formControlKey][props.index] ?? "" : "")
    })
    let temp = journeyState.journeySteps
      let gopaPageIndex =  temp.pages.findIndex(element => element.pageId === "PageFutureDollarGiftCityCalculateFundValue");
      let gopaSectionIndex = temp.pages[gopaPageIndex].sections.findIndex(element => element.sectionId === "SectionCommonResidenceAndOccupation")
    if(journeyState?.journeyData[gopaPageIndex]?.pageData[gopaSectionIndex]?.sectionData?.GOPAcountry == "AE") {
      let bankName = lookup["bankName"]
      let temp = journeyState.journeySteps
      let tempPageIndexToChange
      let tempSectionIndexToChange
      let tempComponentGroupIndexToChange
      let tempComponentIndexToChange
      tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageFlexiEdgeFillProposalForm")
      tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionFlexiEdgeFillProposalNomineeDetails")
      tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "proposalFormNomineeDetails")
      tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "bankNameNominee")
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false

      tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "proposalFormNomineeDetails")
      tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "bankBranchNameNominee")
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false

      tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "ifscCodeNominee")
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["label"] = "Swift Code"
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["placeholder"] = "Enter Swift Code"
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["regex"] = null
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["requiredError"] = "Please enter Swift Code"



      return;
    }
  }, [sectionState.sectionData[props.data.formControlKey]?.[props.index]])



  const checkForIfscCodes = (target) => {
    if(journeyState?.journeyData[0]?.pageData[1]?.sectionData?.GOPAcountry == "AE") return;
    if (props.data.formControlKey.toLowerCase().includes("ifsccodenominee") && (target.value && target.value.length === 11)) {
      let payload = {
        "MIR-BNK-IFSC-CD": target.value
      }
      ifscCodeDetails(payload)
        .then(res => {
          console.log(res.data)
          if(res?.data?.allUniqueBankName){
            let bankNameList = res?.data?.allUniqueBankName
            let bankName = []
            bankName.push(bankNameList)
            let bankBranchNameList = res?.data?.bankAddress[Object.keys(bankNameList)[0]]
            let temp = journeyState.journeySteps
            let tempPageIndexToChange
            let tempSectionIndexToChange
            let tempComponentGroupIndexToChange
            let tempComponentIndexToChange
            tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageFlexiEdgeFillProposalForm")
            tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionFlexiEdgeFillProposalNomineeDetails")
            tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "proposalFormNomineeDetails")
            tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "bankNameNominee")
            temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = bankName
            temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
            setJourneyState(prev => {
              return ({
                ...prev,
                journeySteps: temp
              })
            })
            if(Object.keys(bankNameList)?.length === 1){
              let bank = Object.keys(bankNameList)[0]
              let bankBranchName =  Object.keys(bankBranchNameList)[0]

              let temp1 = sectionState.sectionData["bankNameNominee"] || []
              let temp2 = sectionState.sectionData["bankBranchNameNominee"] || []
              if (!Array.isArray(temp1)){
                temp1 = [...temp1]
              }
              if (!Array.isArray(temp2)){
                temp2 = [...temp2]
              }
              temp1[props.index] = bank
              temp2[props.index] = bankBranchName
              setSectionState(prev => {
                return ({
                  ...prev,
                  sectionData: {
                    ...prev.sectionData,
                    bankNameNominee: temp1,
                    bankBranchNameNominee: temp2
                  }
                })
              })
            }
          }
          else{
            let bankName = lookup["bankName"]
            let temp = journeyState.journeySteps
            let tempPageIndexToChange
            let tempSectionIndexToChange
            let tempComponentGroupIndexToChange
            let tempComponentIndexToChange
            tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageFlexiEdgeFillProposalForm")
            tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionFlexiEdgeFillProposalNomineeDetails")
            tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "proposalFormNomineeDetails")
            tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "bankNameNominee")
            temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = bankName
            temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
      
            tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "proposalFormNomineeDetails")
            tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "bankBranchNameNominee")
            temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = bankName
            temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true


            let temp1 = sectionState.sectionData["bankNameNominee"] || []
            let temp2 = sectionState.sectionData["bankBranchNameNominee"] || []
            temp1[props.index] = ""
            temp2[props.index] = ""

            setSectionState(prev => {
              return ({
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  bankNameNominee: temp1,
                  bankBranchNameNominee: temp2
                }
              })
            })
            setJourneyState(prev => {
              return ({
                ...prev,
                journeySteps: temp
              })
            })
          }
        })
        .catch((err) => {
          console.log("please enter valid ifsc code", err);
        })
    }
  }

  const handleChange = ({ target }) => {
    if (numToWordFormControlKey.includes(props.data.formControlKey) || props.data.formControlKey.toLowerCase().includes("sumassured")) {
      let regex = new RegExp(/^\d+$/)
      if (regex.test(target.value.replace(/,/g, ""))) {
        let temp = target.value.split(",")
        target.value = temp.join("")
        // target.value = target.value.replaceAll(",", "")
      } else if (target.value == "") {
        target.value = ""
      }
      else {
        return
      }
    }


    if (sectionState.sectionId === props.sectionId) {
      let temp
      if (sectionState.sectionData[props.data.formControlKey]) {
        let temp1 = sectionState.sectionData[props.data.formControlKey]
        if (props.data.formControlKey === "ifscCodeNominee"){
          temp1[props.index] = target.value?.toUpperCase() ?? ""
        }else{
          temp1[props.index] = wordCapital(target.value ?? '');
        }
        temp = temp1
      } else {
        let temp1 = []
        temp1[props.index] = wordCapital(target.value ?? '')
        temp = temp1
      }
      setSectionState(prev => {
        return {
          ...prev,
          sectionData: {
            ...prev.sectionData,
            [props.data.formControlKey]: temp,
          },
        }
      })
    } else {
      let temp
      if (sectionState.sectionData[props.data.formControlKey]) {
        let temp1 = sectionState.sectionData[props.data.formControlKey]
        temp1[props.index] = wordCapital(target.value ?? '');
        temp = temp1
      } else {
        let temp1 = []
        temp1[props.index] = wordCapital(target.value ?? '')
        temp = temp1
      }
      setSectionState(prev => {
        return {
          ...prev,
          sectionId: props.sectionId,
          sectionData: {
            ...prev.sectionData,
            [props.data.formControlKey]: temp,
          },
        }
      })
    }
    validate(target)
    // console.log(sectionState, "section state")
  }

  return (
    <>
       <InputContainer channel={props.channel} className={`form-group ${props.data.disabled ? 'disable-input' : ''}`} key={props.data.formControlKey + props.index} style={{marginTop:"5px !important"}}>
        <label
          className={`input-label ${props.data.label ? '' : "no-label"} `}
          htmlFor={props.data.id ? props.data.id : props.data.label}
        >
          {(getValueFromJourney(
            journeyState.lookup.label,
            props.data.label
          )) || props.data.label}
        </label>
        <div className="form-control str-input">
          <input
            type="text"
            style={{
              width: numToWordFormControlKey.includes(props.data.formControlKey) || props.data.formControlKey.toLowerCase().includes("sumassured")
                ? "40%"
                : "100%",
            }}
            className={(isIE ? 'IELineHeight' : '')}
            name={+Date.now()}
            autoComplete="new-password"
            required={props.data.required}
            placeholder={(getValueFromJourney(
              journeyState.lookup.placeholder,
              props.data.placeholder
            )) || props.data.placeholder}
            disabled={props.data.disabled}
            id={props.data.id ? props.data.id + props.index : props.data.label + props.index}
            onChange={handleChange}
            value={
              (sectionState.sectionData[props.data.formControlKey] && sectionState.sectionData[props.data.formControlKey][props.index])
                ? numToWordFormControlKey.includes(props.data.formControlKey) || props.data.formControlKey.toLowerCase().includes("sumassured")
                  ? applyComma(
                    sectionState.sectionData[props.data.formControlKey][props.index]
                  )
                  : sectionState.sectionData[props.data.formControlKey][props.index]
                : ""
            }
            onBlur={e => {
              validate(e.target)
              if (props.data.formControlKey === "ifscCodeNominee" || props.data.formControlKey === "ifscCode") {
                checkForIfscCodes(e.target)
              }
            }}
          />
          <span
            style={{
              fontSize: "10px"
            }}
          >
            {numToWordFormControlKey.includes(props.data.formControlKey) || props.data.formControlKey.toLowerCase().includes("sumassured")
              ? insWords(sectionState.sectionData[props.data.formControlKey] ? sectionState.sectionData[props.data.formControlKey][props.index] : '',false,"international")
              : null}
          </span>
        </div>
        <span className="input-error2">
          {(props.showError || showLocalError) && (
            Array.isArray(errorState?.[props.data.formControlKey])
              ? errorState?.[props.data.formControlKey]?.[props.index]
              : errorState?.[props.data.formControlKey]
          )
          }
        </span>
      </InputContainer>
    </>
  )
}
